import React, { FC, memo, useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Block, Button, Grid, Icon, Select, Spinner, } from '@prometheus/components';

import { FormActionsContainer, FormElement, SecondaryContentWrapper, } from '@prometheus/features';

import { getListCentralHosts } from '@/api';

interface PublishDataSourceFormInterfaceProps {
  dataSourceId: string;
  onCancel: any;
  onPublish: any;
  createMethod: any;
}

export const PublishDataSourceForm: FC<PublishDataSourceFormInterfaceProps> =
  memo(props => {
    const { dataSourceId, onCancel, onPublish, createMethod } = props;
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [centrals, setCentrals] = useState([]);
    const [state, setState] = useState<any>({
      centralIds: [],
    });

    const onPublishDataSource = useCallback(async () => {
      setIsLoading(true);
      try {
        await createMethod(dataSourceId, {
          centralId: state.centralIds[0],
        });

        setTimeout(() => {
          onPublish();
          setIsLoading(false);
        }, 4000);
      } catch (e) {}
    }, [state]);

    useEffect(() => {
      getListCentralHosts().then(list => {
        setCentrals(
          list.content.map(item => {
            return {
              value: item.id,
              name: item.address,
            };
          })
        );
        if (list.content.length === 1) {
          setState({
            centralIds: [list.content[0].id],
          });
        }
      });
    }, []);

    return (
      <Grid container>
        <SecondaryContentWrapper>
          <Block>
            <Grid container spacing={2} p={2}>
              <Grid item xs={12}>
                <FormElement
                  name="type"
                  textLabel={t('forms.centrals')}
                  required
                >
                  <Select
                    className=""
                    name="type"
                    disablePortal
                    id="type"
                    options={centrals}
                    value={state.centralIds}
                    placeholder={t('forms.centrals_placeholder')}
                    multiple={centrals.length > 1}
                    onChange={(central: any) => {
                      setState({
                        ...state,
                        centralIds: [central],
                      });
                    }}
                    fullWidth
                  />
                </FormElement>
              </Grid>
              <Grid item xs={12}>
                <FormActionsContainer>
                  <Button
                    variant="outlined"
                    disabled={isLoading}
                    onClick={onCancel}
                    startIcon={<Icon iconName="deactivate" />}
                  >
                    {t('buttons.cancel')}
                  </Button>
                  <Button
                    disabled={isLoading || state.centralIds.length == 0}
                    onClick={onPublishDataSource}
                    variant="contained"
                    color="success"
                    startIcon={
                      isLoading ? (
                        <Spinner size={16} />
                      ) : (
                        <Icon iconName="submit" />
                      )
                    }
                  >
                    {t('buttons.publish_database')}
                  </Button>
                </FormActionsContainer>
              </Grid>
            </Grid>
          </Block>
        </SecondaryContentWrapper>
      </Grid>
    );
  });
